import { render } from "./PipesButton.vue?vue&type=template&id=b5513178&scoped=true"
import script from "./PipesButton.vue?vue&type=script&lang=js"
export * from "./PipesButton.vue?vue&type=script&lang=js"

import "./PipesButton.vue?vue&type=style&index=0&id=b5513178&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5513178"]])

export default __exports__